<template>
  <!-- Rounded switch -->
  <label class="switch">
    <input v-model="isActive" type="checkbox" />
    <span class="slider round"></span>
  </label>
</template>

<script>
import { ref, onMounted, onUpdated } from "vue";
export default {
  props: ["userInfos", "app"],
  emits: ["updatedaccess"],
  setup(props, { emit }) {
    const isActive = ref(false);

    onMounted(() => {
      isActive.value = props.userInfos.apps.find(
        (a) => a.id_app == props.app?.id_app
      )
        ? true
        : false;
    });

    onUpdated(() => {
      emit("updatedaccess", isActive.value);
    });

    return {
      isActive,
    };
  },
};
</script>

<style lang="scss" scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: var(--mainBlue);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--mainBlue);
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>